import { setGlobalState } from '../App.state';
import Cookies from 'js-cookie';

export function logout() {
  document.location.hash = 'logout';
  setGlobalState('authUser', null);
  Cookies.remove('intranetAuthUser');
}
